// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { isTestValid } = require('../utilities/RASuitabilityTestHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const checkStatusInProgress = () => ({
    type: actionTypes.RA_CHECK_STATUS_REQUEST,
});

const checkStatusSuccess = response => ({
    type: actionTypes.RA_CHECK_STATUS_SUCCESS,
    payload: response,
});

const checkStatusFailure = error => ({
    type: actionTypes.RA_CHECK_STATUS_FAILURE,
    payload: error,
});

const checkStatus = () => dispatch => {
    dispatch(checkStatusInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('raCheckStatus'))
        .then(response => {
            dispatch(checkStatusSuccess(response));
        })
        .catch(error => {
            if (error.error) {
                dispatch(checkStatusFailure(error.error.description));
            } else {
                throw error;
            }
        });
};

const checkLandingRedirection = () => (dispatch, getState) => {
    const immCheckStatus = getState().raCheckStatus;
    const immRAGlobalPosition = getState().raGlobalPosition;
    const hasRobo = immRAGlobalPosition.get('hasRoboHired');
    let redirectUrl = 'broker/general/robo';
    if (!hasRobo && !isTestValid(immCheckStatus)) {
        redirectUrl = 'robo/test';
    } else if (!hasRobo && isTestValid(immCheckStatus)) {
        redirectUrl = 'robo/management';
    }
    dispatch({
        type: actionTypes.RA_CHECK_LANDING_REDIRECT,
        payload: {
            redirectUrl: redirectUrl,
        },
    });
};

module.exports = {
    checkStatus,
    checkLandingRedirection,
};
